<template>
    <v-data-table v-bind="{ headers, items, loading }" hide-default-footer>
        <template #top>
            <v-row class="ma-0">
                <v-col cols="auto">
                    <v-text-field v-model="searchDateValue[0]" type="date" v-bind="attrs_input" @input="execSearch" />
                </v-col>
                <v-col cols="auto">
                    <v-text-field v-model="searchDateValue[1]" type="date" v-bind="attrs_input" @input="execSearch" />
                </v-col>
                <v-col cols="auto">
                    <v-text-field v-model="searchValue" v-bind="attrs_input" placeholder="이름/아이디를 입력하세요" @keydown.enter="execSearch">
                        <template #append-outer>
                            <v-btn class="mt-n8" v-bind="{ loading }" @click="execSearch">검색</v-btn>
                        </template>
                    </v-text-field>
                </v-col>
                <v-spacer />
                <v-col cols="auto">
                    <v-btn dark color="green" v-bind="{ loading }" @click="excel"> <v-icon class="mr-8">mdi-microsoft-excel</v-icon> 엑셀 다운로드</v-btn>
                </v-col>
            </v-row>
            <v-divider />
        </template>

        <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" v-html="header.formatter.bind(item)(value)" /> </template>

        <template #footer>
            <v-divider />
            <v-pagination v-model="page" :length="pageCount" :total-visible="11" color="primary" class="mt-n44 mb-16" @input="search" />
        </template>
    </v-data-table>
</template>

<script>
import { attrs_input } from "@/assets/variables";

import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import api from "@/api";
import { mapState } from "vuex";

// const formatter_dateTime = (value) => value?.toDateTime?.() || "-";
const formatter_dateTime = (value) => ((dateTime) => dateTime.slice(0, dateTime.lastIndexOf(":")))(value?.toDateTime?.() || "") || "-";

export default {
    components: {
        VDateField,
    },
    props: {
        isActive: { type: Boolean, default: false },
    },
    data: () => ({
        watches: [],
        summary: { totalCount: 0 },

        page: 1,
        limit: 10,

        searchValue: null,
        searchDateValue: [null, null],

        loading: false,

        attrs_input,
    }),
    computed: {
        ...mapState("lecture", ["_lecture", "lecture"]),
        headers() {
            return [
                { text: "이름", value: "watcher.name" },
                { text: "아이디", value: "watcher.username" },
                {
                    text: "시청시작",
                    value: "startedAt",
                    formatter: formatter_dateTime,
                },
                {
                    text: "시청종료",
                    value: "stoppedAt",
                    formatter: formatter_dateTime,
                },
                { text: "시청시간", value: "meta.viewing.time" },
            ].map((item) => ({
                ...item,
                formatter: item?.formatter ?? ((value) => value ?? "-"),
            }));
        },
        items() {
            return [...(this.watches || [])];
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let params = {};

            if (this.searchDateValue.some((item) => !!item)) {
                params.searchDateValue = this.searchDateValue;
            }

            if (this.searchValue) {
                params.searchValue = this.searchValue;
            }

            return params;
        },
    },
    methods: {
        async init() {
            this.watches = [];
            this.summary = { totalCount: 0 };
            this.page = 1;
            this.searchValue = null;
            this.searchDateValue = [null, null];
            this.loading = false;
            this.search();
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params, _lecture } = this;
                const { watches, summary } = await api.v1.company.lectures.watches.gets({
                    _lecture,
                    headers: { skip, limit },
                    params,
                });
                this.watches = watches;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },

        async excel() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { params, _lecture } = this;
                const { watches } = await api.v1.company.lectures.watches.gets({
                    _lecture,
                    params,
                });

                let fileName = `${this.lecture?.subject?.replaceAll(/\s/g, "_")}-시청목록`;
                this.$excel(watches, this.headers, fileName);
            } finally {
                this.loading = false;
            }
        },

        execSearch() {
            this.page = 1;
            this.search();
        },
    },
    watch: {
        isActive() {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style>
</style>